import React from 'react';
import { useSelector } from 'react-redux';

function EmployerApplications() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <div className="py-4">
      <h1>Aplikacje</h1>
      <div className="alert alert-info">
        Przeglądanie aplikacji dla: <strong>{userInfo?.company_name}</strong>
      </div>
      <p>Tutaj pojawią się funkcje do zarządzania aplikacjami od kandydatów</p>
    </div>
  );
}

export default EmployerApplications;
